export default __webpack_public_path__ + "static/media/alumisoft_branco.25bd16d8.svg";